import { sassTrue } from "sass";
import axios from "../../service";
import fn from "@/helpers/utility";
import moment from "moment";
import alert from "@/_helpers/alert";
import { ReportService } from "../resources";

export const state = {
  reportPickup: {
    report: [],
    total: 0
  },
  reportTranAffiliate: {
    report: [],
    total: 0
  },
  storeSelectApproveCod: {},
  idCod: "0",
  keyAuth: {
    key: "finance_flag",
    keyAdvance: "advanced_finance_flag"
  }
};

export const mutations = {
  TEST(state, newValue) {},

  KEY_AUTH_UPDATE(state, newValue) {
    state.keyAuth.keyAdvance = newValue;
  },

  INIT_REPORT_PICKUP(state, newValue) {
    state.reportPickup.report = newValue.report;
    state.reportPickup.total = newValue.total;
  },
  INIT_REPORT_AFFILIATE(state, newValue) {
    if (newValue.length === 0 || !newValue) {
      state.reportTranAffiliate.report = [];
      state.reportTranAffiliate.total = 0;
    } else {
      state.reportTranAffiliate.report = newValue.report;
      state.reportTranAffiliate.total = newValue.total;
    }
  },

  INIT_SET_PAGE_SELECT_APPROVE_COD(state, newValue) {
    state.storeSelectApproveCod = newValue;
  },

  INIT_SET_ID_COD(state, newValue) {
    state.idCod = newValue;
  }
};

export const getters = {
  PermissionFlag(state) {
    return () => {
      return fn.PermissionFlag(state.keyAuth.keyAdvance);
    }
  }
};

export const actions = {
  // async getReportPickup({ commit }, data) {
  //     try {
  //         let resp = await axios.get("/user/report/pickup", {
  //             params: {
  //                 ...data
  //             }
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง";
  //         commit("INIT_REPORT_PICKUP", resp.data);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },
  async loadTransection({ commit }, data) {
    try {
      let resp = await ReportService.apiGetTransection(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadTransectionCOD({ commit }, data) {
    try {
      let resp = await ReportService.apiGetloadTransectionCOD(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadRefillWallet({ commit }, data) {
    try {
      let resp = await ReportService.apiGetRefillWallet(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadReportCod({ commit }, data) {
    try {
      let resp = await ReportService.apiGetReportCod(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadReportPickup({ commit }, data) {
    try {
      let resp = await ReportService.apiGetReportPickup(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async loadReportAffiliate({ commit }, data) {
    try {
      let resp = await ReportService.apiGetReportAffiliate(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getKeyConnect({ commit }, data) {
    try {
      let resp = await ReportService.apiGetKeyConnect(data)
      return { status: true, ...resp };      
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async generateKeyReport({ commit }, data) {
    try {
      let resp = await axios({
        method: "PATCH",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/api-key`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json"
        }
      })
        .then((success) => {
          return success;
        })
        .catch((err) => {
          console.error(err.message, "message");
        });
      return { status: true, data: resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getCodApprove({ commit }, data) {
    try {
      let resp = await ReportService.apiGetgetCodApprove(data);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getCodApproveByid({ commit }, id) {
    try {
      let resp = await ReportService.apiGetCodApproveByid(id)
      return { status: true, ...resp };      
    } catch (err) {
      return { status: false, err: err };
    }
  },

  async getParceShipmentCod({ commit }, id) {
    try {
      let resp = await ReportService.apiGetParceShipmentCod(id);
      return { status: true, ...resp };
    } catch (err) {
      return { status: false, err: err };
    }
  },
  async exportCodApproval({ commit }, id) {
    try {
      let resp = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/wallet/cod-approvals/${id}/shipment-orders/export`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json"
        },
        responseType: "blob",
        timeout: 300000,
        maxContentLength: 1073741824
      })
        .then((response) => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไมไ่ด้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch((err) => {
          console.error(err.message, "message");
          return err.message;
        });
      if (typeof resp == "string") {
        return { status: false, data: {}, message: resp };
      } else {
        return { status: true, data: resp };
      }
    } catch (err) {
      console.error(err.message, "message");
    }
  },

  async getCodOrder({ commit }, data) {
    try {
      let resp = await ReportService.apiGetCodOrder(data)
      return { status: true, ...resp,statusX:'test' };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getCodOrderSummary({ commit }, data) {
    try {
      let resp = await ReportService.apiGetCodOrderSummary(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getCodOrderSummaryMoney({ commit }, data) {
    try {
      let resp = await ReportService.apiGetCodOrderSummaryMoney(data);
      return { status: true, ...resp };
    } catch (e) {
      return { status: false, err: err };
    }
  },

  async getHistoryInsurance({ commit }, data) {
    try {
      let resp = await ReportService.apiGetHistoryInsurance(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, 'message-catch');
      return { status: false, err: err };
    }
  },

  async exportOrderCodFile({ commit }, data) {
    try {
      let resp = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v2/reports/shipment-orders/cod/export`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json"
        },
        responseType: "blob",
        timeout: 300000,
        maxContentLength: 1073741824,
        params: data
      })
        .then((response) => {
          let dataStr = fn.cutFileName(response.headers["content-disposition"]);
          let format = dataStr.split(".");
          format = format[format.length - 1];
          let url;
          if (response?.headers) {
            if (format == "xlsx") {
              url = window.URL.createObjectURL(new Blob([response.data]));
            } else if (format == "csv") {
              var BOM = "\uFEFF"; // utf-8 ใส่ตัวนี้
              url = window.URL.createObjectURL(new Blob([BOM + response.data]));
            } else {
              alert.error("export file ไมไ่ด้");
            }
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", dataStr);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch((err) => {
          console.error(err.message, "message");
          return err.message;
        });
      if (typeof resp == "string") {
        return { status: false, data: {}, message: resp };
      } else {
        return { status: true, data: resp };
      }
    } catch (err) {
      console.error(err.message, "message");
    }
  }

  // v1/wallet/cod-approvals
};
